export default "__VITE_ASSET__66ffba44__"